import React from 'react';
import { Flex, Box, TextV2 } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { useTranslation } from '@shared/core';

type AccordionOnOffBadgeProps = {
  label?: string;
  isEnabled: boolean;
  onClick: () => void;
};

export const AccordionOnOffBadge: React.FC<AccordionOnOffBadgeProps> = ({ label, isEnabled, onClick }) => {
  const { t2 } = useTranslation('adminDashboardV3');
  const { onBadgeLabel, offBadgeLabel } = t2('dashboardAccordion', 'onOffBadge');
  const onOffLabel = isEnabled ? onBadgeLabel : offBadgeLabel;

  return (
    <Flex
      cursor={'pointer'}
      alignItems={'center'}
      columnGap={2}
      paddingX={3}
      paddingY={1}
      borderRadius={5}
      backgroundColor={'transparent'}
      transition={animationTransition('background-color')}
      _hover={{ backgroundColor: 'mono2' }}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Box width={2} height={2} borderRadius={'100%'} backgroundColor={isEnabled ? 'accentGreen3' : 'red4'} />
      <TextV2 typographyVariant={'label1'} color={'mono10'}>
        {label} {onOffLabel}
      </TextV2>
    </Flex>
  );
};
